import { render, staticRenderFns } from "./RHumanos.vue?vue&type=template&id=4794f2aa&"
import script from "./RHumanos.vue?vue&type=script&lang=js&"
export * from "./RHumanos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports